import {
  LOADING
} from '../constants/ActionTypes'

export const doLoading = () => ({ type: LOADING })
